import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useAuth, TIER_FREE } from "../App";

const FloatingAIButton = () => {
  const navigate = useNavigate();
  const { user, isMemberOrAbove } = useAuth();
  const [showLocked, setShowLocked] = useState(false);

  const handleClick = () => {
    if (isMemberOrAbove()) {
      navigate("/ai");
    } else {
      setShowLocked(true);
      setTimeout(() => setShowLocked(false), 3000);
    }
  };

  return (
    <>
      <button
        onClick={handleClick}
        className="fixed bottom-36 right-4 z-50 w-14 h-14 rounded-full bg-[#0B3D2E] text-white flex items-center justify-center shadow-lg hover:scale-105 active:scale-95 transition-transform"
        data-testid="floating-ai-btn"
      >
        <Sparkles className="w-6 h-6" />
      </button>

      {/* Locked Overlay */}
      {showLocked && (
        <div className="fixed bottom-52 right-4 z-50 bg-white rounded-xl shadow-lg p-3 max-w-[200px] border border-[#0B3D2E]/10 animate-in fade-in slide-in-from-bottom-2">
          <p className="text-sm text-[#051F17] font-medium">Hauora AI</p>
          <p className="text-xs text-[#4A5D56] mt-1">
            Available for TRIBE members.
          </p>
        </div>
      )}
    </>
  );
};

export default FloatingAIButton;
